import api from '@/utils/api'

export function getTwoFAStatus(options) {
  return api.post('/twofa/status', {}, options)
}

export function setupTwoFA(options) {
  return api.post('/twofa/setup', {}, options)
}

export function enableTwoFA(params, options) {
  return api.post('/twofa/enable', params, options)
}

export function disableTwoFA(params, options) {
  return api.post('/twofa/disable', params, options)
}

export function verifyLogin(params, options) {
  return api.post('/twofa/verify_login', params, options)
}
